import styled from 'styled-components';

export const FLOATING_CARD_Z_INDEX = 1050;
/** Below antd Modal default (1000) so portaled cards stay behind image modals. */
export const FLOATING_CARD_BELOW_MODAL_Z_INDEX = 999;

export const FloatingContainer = styled.div<{
  $left: number;
  $top: number;
  $width: number;
  $height: number;
  $zIndex?: number;
}>`
  position: fixed;
  left: ${({ $left }) => $left}px;
  top: ${({ $top }) => $top}px;
  width: ${({ $width }) => $width}px;
  height: ${({ $height }) => $height}px;
  z-index: ${({ $zIndex = FLOATING_CARD_Z_INDEX }) => $zIndex};
  overflow: hidden;
  box-sizing: border-box;
  pointer-events: auto;
`;

export const FloatingCardFrame = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  border: 1px solid ${({ theme }) => theme.tableHeaderButtonColor};
  background: ${({ theme }) => theme.secondaryBackgroundColor};
  box-shadow: 0 4px 12px ${({ theme }) => theme.darkShadow};
  box-sizing: border-box;
`;

export const FloatingHeader = styled.div`
  display: flex;
  align-items: center;
  padding: calc(4px * var(--floating-card-scale, 1)) calc(8px * var(--floating-card-scale, 1));
  border-bottom: 1px solid ${({ theme }) => theme.tableHeaderButtonColor};
  cursor: move;
  user-select: none;
  flex-shrink: 0;
  gap: calc(6px * var(--floating-card-scale, 1));
  background: ${({ theme }) => theme.tertiaryBackgroundColor};
`;

export const FloatingHeaderTitle = styled.span`
  flex-grow: 1;
  text-transform: uppercase;
  font-size: calc(12px * var(--floating-card-scale, 1));
  font-weight: 400;
`;

export const FloatingContent = styled.div`
  flex: 1;
  min-height: 0;
  overflow: hidden;
  position: relative;
  background: ${({ theme }) => theme.secondaryBackgroundColor};
`;

export const CornerHandle = styled.div<{
  $cursor: string;
  $top?: number;
  $bottom?: number;
  $left?: number;
  $right?: number;
}>`
  position: absolute;
  width: 14px;
  height: 14px;
  z-index: 2;
  cursor: ${({ $cursor }) => $cursor};
  ${({ $top }) => ($top !== undefined ? `top: ${$top}px;` : '')}
  ${({ $bottom }) => ($bottom !== undefined ? `bottom: ${$bottom}px;` : '')}
  ${({ $left }) => ($left !== undefined ? `left: ${$left}px;` : '')}
  ${({ $right }) => ($right !== undefined ? `right: ${$right}px;` : '')}
`;
